export const selectCheckUserExists = ({ signup }) => signup.checkUserExists;
